import React, { useContext } from "react";
import { AuthContext } from "../../../../context/AuthContext";
type CaseStudy = {
  title: string;
  highlited: string;
  icon: string;
  name: string;
  date: number;
  className?: string;
  subtitle: string;
};

const CaseHero = ({
  title,
  highlited,
  icon,
  name,
  date,
  subtitle,
  className,
}: CaseStudy) => {
  const dataContext = useContext(AuthContext);

  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div
      className={`${
        theme === "dark" ? "" : "bg-black text-white"
      } transition-all duration-500 relative overflow-hidden`}
    >
      <div className="max-w-screen-2xl mx-auto">
        <div
          className={`w-full py-8 px-5 sm:py-20 sm:px-10 lg:px-20  ${className}`}
        >
          <div className={`${className}`}>
            <h1
              className={`bricolage-grotesque-bold text-4xl sm:text-5xl font-bold mb-9 sm:w-[80%] text-center sm:text-left ${className}`}
            >
              {title} <span className="text-gradient">{highlited}</span>
            </h1>
            <div className="flex flex-col-reverse lg:flex-row justify-between lg:items-center">
              <div className="flex flex-col sm:flex-row lg:justify-center items-center gap-5 lg:gap-10 mb-4 sm:mb-0">
                <img src={icon} alt="softside" className={` ${className}`} />
                <h2
                  className={`font-gtAmerica font-semibold text-2xl sm:text-3xl ${className}`}
                >
                  {name}
                </h2>
              </div>
              <p className={`font-montserrat text-2xl opacity-50 text-center sm:text-left my-5 sm:my-0 ${className}`}>
                {date}
              </p>
              <p
                className={`font-montserrat text-2xl lg:w-[50%] text-center sm:text-left ${className}`}
              >
                {subtitle}
              </p>
            </div>
          </div>
        </div>
      </div>
      <svg
        width="1444"
        height="1292"
        viewBox="0 0 1444 1292"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute top-[200px] sm:top-[50px] -left-[60%] sm:left-0 sm:right-0 sm:mx-auto h-[1000px] sm:h-auto w-[1000px] sm:w-full"
      >
        <g filter="url(#filter0_f_3562_1617)">
          <ellipse cx="722" cy="646" rx="643" ry="393" fill="#8D19DA" />
        </g>
        <defs>
          <filter
            id="filter0_f_3562_1617"
            x="-173.6"
            y="0.399994"
            width="1791.2"
            height="1291.2"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="126.3"
              result="effect1_foregroundBlur_3562_1617"
            />
          </filter>
        </defs>
      </svg>
      <svg
        width="790"
        height="786"
        viewBox="0 0 790 786"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute left-0 right-0 mx-auto top-[280px] sm:top-[400px] w-full sm:w-auto h-full positive-animate-spin1"
      >
        <path
          d="M789.5 393C789.5 609.769 612.879 785.5 395 785.5C177.121 785.5 0.5 609.769 0.5 393C0.5 176.231 177.121 0.5 395 0.5C612.879 0.5 789.5 176.231 789.5 393Z"
          stroke="#727272"
        />
        <g filter="url(#filter0_f_3804_1744)">
          <circle cx="136" cy="95" r="9" fill="#F20B97" />
        </g>
        <defs>
          <filter
            id="filter0_f_3804_1744"
            x="113"
            y="72"
            width="46"
            height="46"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="7"
              result="effect1_foregroundBlur_3804_1744"
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
};

export default CaseHero;
